/**
 * FlashAlerts is the map normally from the editorStore.flashAlerts
 */
export type FlashAlerts = Map<string, FlashAlertData>;
type ToneOptions = "neutral" | "warn" | "critical" | "positive" | "brand-default";
export class FlashAlertData {
  message: string;
  tone: ToneOptions;
  id: string;
  constructor(message: string, tone: ToneOptions) {
    this.message = message;
    this.tone = tone;
    this.id = String(Math.random());
  }
}

export class FlashAlertsManager {
  private readonly flashes: FlashAlerts;

  constructor(flashes: FlashAlerts) {
    this.flashes = flashes;
  }

  create(message: string, tone: ToneOptions, timer: number = 0) {
    const data = new FlashAlertData(message, tone);
    this.flashes.set(data.id, data);

    if (timer) {
      setTimeout(() => this.close(data.id), timer);
    }
  }

  close(id: string) {
    this.flashes.delete(id);
  }
}
